import type { JsonDataItem, ServiceTechnician } from 'types';

export const getPrimaryServiceTechnician = (job?: JsonDataItem | null): ServiceTechnician | undefined => {
  return job?.products?.[0]?.service_technicians?.[0];
};
